import { makeStyles, tokens } from "@fluentui/react-components";

export const rootUseStyles = makeStyles({
    root: {
        overflow: "hidden",
        height: "96vh",
        backgroundColor: tokens.colorNeutralBackground1,
    },
    footer: {
        textAlign: "center",
        color: "#BABABA",
        fontSize: tokens.fontSizeBase200,
        fontWeight: 400,
        position: "absolute",
        bottom: "4px",
        width: "100%",
    },
    paragraph: {
        margin: 0,
    },
    legalLinks: {
        display: "flex",
        justifyContent: "center",
        gap: "10px",
        marginTop: "4px",
    },
    link: {
        color: "#BABABA",
        textDecoration: "none",
        fontSize: tokens.fontSizeBase100,
        "&:hover": {
            textDecoration: "underline",
        },
    },
    buttonWarning: {
        backgroundColor: "#BC1947",
        fontSize: tokens.fontSizeBase200,
        width: "100%",
        color: tokens.colorNeutralForegroundOnBrand,
        fontWeight: tokens.fontWeightSemibold,
        border: `1px solid #BC1947`,
        "&:hover": {
            backgroundColor: "#A00F3D",
            color: tokens.colorNeutralForegroundOnBrand
        },
        "&:disabled, &:disabled:hover": {
            backgroundColor: "#BC194790",
            color: tokens.colorNeutralForegroundOnBrand
        }
    },
    buttonInfo: {
        backgroundColor: "#0A78D5",
        fontSize: tokens.fontSizeBase200,
        width: "100%",
        color: tokens.colorNeutralForegroundOnBrand,
        fontWeight: tokens.fontWeightSemibold,
        border: `1px solid #0A78D5`,
        "&:hover": {
            backgroundColor: "#005A9E",
            color: tokens.colorNeutralForegroundOnBrand
        }
    },
    buttonInfoOutline: {
        width: "100%",
        color: "#0A78D5",
        fontSize: tokens.fontSizeBase200,
        fontWeight: tokens.fontWeightSemibold,
        border: "1px solid #0A78D5",
        "&:hover": {
            color: "#0A78D590",
            border: "1px solid #0A78D590",
            backgroundColor: "transparent",
        }
    },
    scrollbar: {
        scrollbarWidth: "thin",
        scrollbarColor: `${tokens.colorNeutralStroke1} transparent`,
    },

    scrollArea: {
        overflowY: "scroll",
        overflowX: "hidden",
        paddingLeft: "15px",
        paddingRight: "5px",
    }
});